export const normalizeToSlugs = (
    input: string | string[] | undefined
): string[] => {
    if (!input) {
        return []
    }
    if (Array.isArray(input)) {
        return input.filter(Boolean)
    }

    return input
        .split(/[,\s]+/)
        .map((s) => s.trim())
        .filter(Boolean)
}
